/**
 * --- KONSEP: PUSAT PENGATURAN (APP.JS) ---
 * File ini adalah "Peta Utama" aplikasi. Di sini kita menentukan 
 * halaman apa saja yang ada dan siapa saja yang boleh membukanya.
 */
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import NotificationModal from "./components/common/NotificationModal";
import StockNotifier from "./components/common/StockNotifier";
import ProtectedRoute from "./components/layout/ProtectedRoute";

import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";

import Dashboard from "./pages/dashboard/Dashboard";
import Inventory from "./pages/inventory/Inventory";
import EditProduct from "./pages/inventory/EditProduct";
import AddProduct from "./pages/inventory/AddProduct";
import SalesNote from "./pages/sales/NewSale";
import SalesHistory from "./pages/sales/SalesHistory";
import SalesReceipt from "./pages/sales/SalesReceipt";

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          {/* Kotak Pesan Global (Bisa muncul di halaman mana saja) */}
          <NotificationModal />
          <StockNotifier />

          <Routes>
            {/* --- JALUR UMUM (Bisa dibuka Tanpa Login) --- */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            {/* --- JALUR RAHASIA (Harus Login Dulu) --- */}
            {/* ProtectedRoute adalah 'Satpam' yang mengecek status login */}
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/inventory/add" element={<AddProduct />} />
              <Route path="/inventory/edit" element={<EditProduct />} />
              <Route path="/new-sale" element={<SalesNote />} />
              <Route path="/sales-history" element={<SalesHistory />} />
              <Route path="/sales-receipt" element={<SalesReceipt />} />
            </Route>

            {/* Jika alamat yang diketik salah, balikkan ke halaman Login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
